<app-camp-location-search-select
  #searchSelect
  (selectedCampId)="handleSelectedCampId($event)"
></app-camp-location-search-select>
<div style="margin-top: 5rem;">
  <hr>
  <footer class="flex-sm-row flex-column-reverse row no-gutters footer-action div-footer">
    <div class="col pr-sm-1">
      <button
        class="btn btn-outline-danger btn-block"
        (click)="cancelSelect()"
      >Cancel</button>
    </div>
    <div class="col pl-sm-1">
      <button
        class="btn btn-danger btn-block mb-2 mb-sm-0"
        (click)="onConfirmSelect()"
        [disabled]="!isBtnEnabled"
      >Select</button>
    </div>
  </footer>
</div>
